import cn from 'classnames';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';

import { NAVIGATION_PANEL_DISPLAY_TYPE } from '../../../constants/analytics';
import { PAGE_LAYOUT_NAVIGATION_PANEL_SET_DISPLAY_TYPE } from '../../../store/reducers/pageLayout';

import { NavigationPanelExpandIcon } from '../../icons/analytics';
import { NavigationPanelSection } from './NavigationPanelSection';

import styles from './NavigationPanel.module.scss';

export function NavigationPanel({ prefix, items }) {
  const { displayType } = useSelector((state) => state.pageLayout.navigationPanel);
  const dispatch = useDispatch();

  const toggleDisplayType = () => {
    dispatch({
      type: PAGE_LAYOUT_NAVIGATION_PANEL_SET_DISPLAY_TYPE,
    });
  };

  return (
    <div
      className={cn(styles.navigationPanel, displayType === NAVIGATION_PANEL_DISPLAY_TYPE.FULL ? '' : styles.collapsed)}
    >
      <nav>
        {items.map((item) => (
          <NavigationPanelSection key={item.title} item={item} prefix={prefix} path={item.title.toLowerCase()} />
        ))}
      </nav>

      <div onClick={toggleDisplayType} className={styles.deadZone}></div>

      <footer>
        <div className={styles.footer}>
          <button onClick={toggleDisplayType}>
            <NavigationPanelExpandIcon />
          </button>
        </div>
      </footer>
    </div>
  );
}

NavigationPanel.propTypes = {
  prefix: PropTypes.string.isRequired,
  items: PropTypes.array.isRequired,
};
